import type { CardStatus, CardTransactionStatus } from '../cards.types';

export type TagSeverity = 'success' | 'danger' | 'info' | 'warn' | 'secondary';

interface StatusTag {
  severity: TagSeverity;
  labelKey: string;
  icon?: string;
}

const cardStatusTags: Record<CardStatus, StatusTag> = {
  active: { severity: 'success', labelKey: 'cards.status.active' },
  blocked: { severity: 'warn', labelKey: 'cards.status.blocked', icon: 'pi pi-ban' },
  deactivated: { severity: 'danger', labelKey: 'cards.status.deactivated', icon: 'pi pi-trash' },
  ordered: { severity: 'info', labelKey: 'cards.status.ordered' },
  being_delivered: { severity: 'info', labelKey: 'cards.status.being_delivered' },
  delivered: { severity: 'info', labelKey: 'cards.status.delivered' },
};

export const cardStatusTag = (status: CardStatus): StatusTag => cardStatusTags[status];

const transactionStatusTags: Record<CardTransactionStatus, StatusTag> = {
  completed: { severity: 'success', labelKey: 'cards.transaction_status.completed' },
  processing: { severity: 'info', labelKey: 'cards.transaction_status.processing' },
  failed: { severity: 'danger', labelKey: 'cards.transaction_status.failed' },
  missing_otp: { severity: 'danger', labelKey: 'cards.transaction_status.missing_otp' },
};

export const transactionStatusTag = (status: CardTransactionStatus): StatusTag =>
  transactionStatusTags[status];

export const isCardOperational = (status: CardStatus) => status === 'active';
